import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4" onClick={onClose}>
      <div
        className="bg-white dark:bg-cap-dark rounded-lg shadow-xl w-[calc(100%-2rem)] mx-4 sm:max-w-md md:max-w-lg lg:max-w-2xl max-h-[90vh] overflow-auto relative"
        onClick={e => e.stopPropagation()}
      >
        {children}
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 dark:text-gray-300 text-2xl font-bold min-w-[48px] min-h-[48px] flex items-center justify-center"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </div>,
    document.body
  );
};

export default Modal; 